import { useState } from "react";

import { Video } from "vimeo";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Button, Input } from "@vimeo/iris/components";
import { sendAnalyticsEvent, WorkflowEventNames } from "../analytics/common";
import { getVideoIdFromUri } from "../common";

interface Props {
    video: Video;
}

const defaultButtonLabel = "Copy link";

export function CopyVideoLink(props: Props) {
    const [buttonLabel, setButtonLabel] = useState(defaultButtonLabel);

    function onCopy() {
        sendAnalyticsEvent(WorkflowEventNames.copyVideoLink, {
            actor_resource_role: null, //constant
            actor_team_role: null, //constant
            entry_page: null, //constant
            is_preset_applied: null, //constant
            page: null, //constant
            path: null, //constant
            team_owner_id: null, //constant
            team_permission_level: null, //constant
            team_size: null, //constant
            team_subscription_type: null, //constant
            timestamp_appended: null, //constant
            upload_id: null, //constant
            video_app_id: null, //constant
            video_status: null, //constant
            video_type: null, //constant
            is_china_delivery_video: null, //constant

            is_video_password_protected: !!props.video.password,
            location: "video_settings",
            video_id: getVideoIdFromUri(props.video.uri),
            video_embed_privacy: props.video.privacy.embed,
            video_privacy: props.video.privacy.view,
        }, 7);

        setButtonLabel("Copied!");
        setTimeout(() => setButtonLabel(defaultButtonLabel), 800);
    }

    return (
        <div
            style={{
                display: "flex",
                flexFlow: "column nowrap",
            }}
        >
            {props.video.privacy.view === "unlisted" && (
                <span className="slds-var-p-bottom_small">
                    <strong>Only people with this link can access.</strong>
                </span>
            )}
            <div style={{ display: "flex", flexFlow: "row nowrap" }}>
                <Input
                    id="copy-link-input"
                    type="url"
                    style={{ flex: 0.7 }}
                    label=""
                    placeholder=""
                    value={props.video.link}
                    disabled={true}
                />
                <CopyToClipboard text={props.video.link} onCopy={onCopy}>
                    <Button
                        style={{
                            alignSelf: "end",
                            marginLeft: "-20px",
                            flex: 0.3,
                        }}
                        format="primary"
                    >
                        {buttonLabel}
                    </Button>
                </CopyToClipboard>
            </div>
        </div>
    );
}
